/**
 * support-i18n — shared i18n instance for all support inbox Preact components.
 *
 * Usage:
 *   import { t } from './support-i18n.js'
 *   t('support.inbox.title')
 */

import { I18n } from 'i18n-js'
import locales from '../../locales.json'

const i18n = new I18n(locales)
i18n.locale = document.querySelector("meta[name='locale']")?.content || 'hu'

export function t(key, opts) {
  return i18n.t(key, opts)
}
